import React from 'react';
import { Link as RouterLink } from "react-router-dom";
import NightingaleLink from './NightingaleLink';
import { LinkText as EcoLinkText } from "@bsw/react-nightingale";
//import './link.scss';

export const LinkText = (props) => {
    const linkAs = props?.as || (props?.to ? RouterLink : undefined);

    return <EcoLinkText
        {...props}
        as={linkAs}
    />;
}

//export const LinkText = ({
//    as,
//    children,
//    href,
//    to,
//    ...linkProps
//}) => {

//    const linkAs = as ? as : (to ? <RouterLink to={to}></RouterLink> : <a href={href}></a>);

//    return (
//        <NightingaleLink
//            {...linkProps}
//            as={linkAs}
//        >
//            {children}
//        </NightingaleLink>
//    );
//};
